// Messages for portal/Team (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'portal.team.head': 'Your team — Portal',
  'portal.team.title': 'Your team',
  'portal.team.desc': 'Manage who can access this portal',
  'portal.team.invite_cta': 'Invite teammate',
  'portal.team.role.member': 'Member',
  'portal.team.role.company_admin': 'Company Admin',
  'portal.team.confirm_remove': 'Remove {email} from your team?',
  'portal.team.invite_link_intro': 'Invite link for',
  'portal.team.invite_link_share': "— share it if email isn't set up yet:",
  'portal.team.copy': 'Copy',
  'portal.team.col.name': 'Name',
  'portal.team.col.email': 'Email',
  'portal.team.col.role': 'Role',
  'portal.team.you': '(you)',
  'portal.team.role_for': 'Role for {email}',
  'portal.team.resend': 'Resend',
  'portal.team.reset': 'Reset',
  'portal.team.enable': 'Enable',
  'portal.team.disable': 'Disable',
  'portal.team.remove': 'Remove {email}',
  'portal.team.status.active': 'Active',
  'portal.team.status.invited': 'Invited',
  'portal.team.status.disabled': 'Deactivated',
}

export const zhTW = {
  'portal.team.head': '您的團隊 — 客戶入口',
  'portal.team.title': '您的團隊',
  'portal.team.desc': '管理可存取此客戶入口的人員',
  'portal.team.invite_cta': '邀請成員',
  'portal.team.role.member': '成員',
  'portal.team.role.company_admin': '公司管理員',
  'portal.team.confirm_remove': '要將 {email} 從您的團隊中移除嗎？',
  'portal.team.invite_link_intro': '邀請連結，提供給',
  'portal.team.invite_link_share': '— 若尚未設定電子郵件，可分享此連結：',
  'portal.team.copy': '複製',
  'portal.team.col.name': '姓名',
  'portal.team.col.email': '電子郵件',
  'portal.team.col.role': '角色',
  'portal.team.you': '（您）',
  'portal.team.role_for': '{email} 的角色',
  'portal.team.resend': '重新傳送',
  'portal.team.reset': '重設',
  'portal.team.enable': '啟用',
  'portal.team.disable': '停用',
  'portal.team.remove': '移除 {email}',
  'portal.team.status.active': '啟用中',
  'portal.team.status.invited': '已邀請',
  'portal.team.status.disabled': '已停用',
}
